var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#F1DCDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6844 49C22.3718 49 22.0877 48.9238 21.8319 48.7716C21.5761 48.6194 21.3772 48.4177 21.2351 48.1666C21.093 47.9155 21.0152 47.6444 21.0015 47.3533C20.9879 47.0622 21.0658 46.7777 21.2351 46.5L37.0072 19.8333C37.1777 19.5556 37.3982 19.3472 37.6688 19.2083C37.9393 19.0694 38.2161 19 38.4992 19C38.7822 19 39.0596 19.0694 39.3312 19.2083C39.6029 19.3472 39.8229 19.5556 39.9911 19.8333L55.7632 46.5C55.9337 46.7777 56.0121 47.0627 55.9985 47.355C55.9848 47.6472 55.9064 47.9177 55.7632 48.1666C55.62 48.4155 55.421 48.6172 55.1664 48.7716C54.9118 48.9261 54.6276 49.0022 54.3139 49H22.6844ZM38.4992 44C38.9823 44 39.3875 43.84 39.7149 43.52C40.0423 43.2 40.2054 42.8044 40.2042 42.3333C40.2031 41.8622 40.0394 41.4666 39.7132 41.1466C39.3869 40.8266 38.9823 40.6666 38.4992 40.6666C38.016 40.6666 37.6114 40.8266 37.2851 41.1466C36.9589 41.4666 36.7952 41.8622 36.7941 42.3333C36.7929 42.8044 36.9566 43.2005 37.2851 43.5216C37.6136 43.8427 38.0183 44.0022 38.4992 44ZM38.4992 39C38.9823 39 39.3875 38.84 39.7149 38.52C40.0423 38.2 40.2054 37.8044 40.2042 37.3333V32.3333C40.2042 31.8611 40.0406 31.4655 39.7132 31.1466C39.3858 30.8278 38.9811 30.6678 38.4992 30.6666C38.0172 30.6655 37.6125 30.8255 37.2851 31.1466C36.9578 31.4678 36.7941 31.8633 36.7941 32.3333V37.3333C36.7941 37.8055 36.9578 38.2016 37.2851 38.5216C37.6125 38.8416 38.0172 39.0011 38.4992 39Z",
    fill: "#BD160A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/alert-error.bc8e77c0cd45208a8565b5785e3696aa.svg";
export { ForwardRef as ReactComponent };